<div *ngIf="message && !isCobrowse" class="gc-chat-message-list-item">
  <div class="system-message" *ngIf="isEventTypePresence; else messageBubble">
    <ng-container *ngIf="isConversationStartMessage">
      <p>{{ 'gcChatBox.conversationStart.chatRoomBegin' | translate }}</p>
      <p>
        {{ 'gcChatBox.conversationStart.customerJoined' | translate: { customerName: contact | gcContactDisplayName } }}
      </p>
      <p>{{ 'gcChatBox.conversationStart.youJoined' | translate }}</p>
    </ng-container>
    <ng-container *ngIf="isConversationEndMessage">
      <p>{{ 'gcChatBox.conversationDisconnected' | translate: { timeStamp: formatDate(message.timestamp) } }}</p>
    </ng-container>
    <ng-container *ngIf="isConversationClearMessage">
      <p>{{ 'gcChatBox.conversationCleared' | translate: { timeStamp: formatDate(message.timestamp) } }}</p>
    </ng-container>
  </div>

  <ng-template #messageBubble>
    <div class="message-bubble">
      <div
        class="message-bubble-card-selection"
        [attr.data-automation-id]="'gc-chat-message-card-selection'"
        *ngIf="isButtonResponse$ | async"
      >{{ 'gcChatBox.cardSelection' | translate }}</div>
      <div
        *ngIf="(isRichMediaType$ | async) === false"
        data-automation-id="message-text"
        [innerHTML]="
          ((shouldFormatMessage$ | async) ? (message.textBody | appMdToHtml) : message.textBody)
            | linky: { newWindow: true, stripPrefix: false }
        "
      ></div>

      <ng-container *ngIf="isRichMediaType$ | async">
        <ng-container *ngFor="let content of message.normalizedMessage.content">
          <app-genesys-chat-message-card
            *ngIf="content.contentType === ConversationMessageContentType.Card"
            [card]="content.card"
          ></app-genesys-chat-message-card>
          <ng-container *ngIf="content.contentType === ConversationMessageContentType.Carousel">
            <app-genesys-chat-message-card
              *ngFor="let card of content.carousel.cards"
              [card]="card"
              class="chat-message-card"
            ></app-genesys-chat-message-card>
          </ng-container>
        </ng-container>
      </ng-container>

      <div class="message-image-container" *ngIf="imageAttachments?.length > 0">
        <img
          *ngFor="let imageAttachment of imageAttachments"
          alt="{{ imageAttachment.text || imageAttachment.filename || '' }}"
          [src]="imageAttachment.url"
          (load)="imageLoad.emit()"
        />
      </div>

      <div class="message-attachments-container" *ngIf="urlBasedAttachments?.length > 0">
        <div
          *ngFor="let attachment of urlBasedAttachments"
          [innerHTML]="attachment.url | linky: { newWindow: true, stripPrefix: false }"
        ></div>
      </div>
    </div>
  </ng-template>

  <div class="message-signature" *ngIf="shouldDisplaySignature()">
    <ng-container *ngIf="getLatestStatus$() | async as latestStatus">
      <i
        class="message-status-icon"
        data-automation-id="message-status-icon"
        *ngIf="latestStatus | appChatMessageStatusIconClass as iconClass"
        class="{{ iconClass }}"
      ></i>
      <span class="message-status-text" data-automation-id="message-status-text">{{
        latestStatus | appChatMessageStatusTranslationKey | translate
      }}</span>
    </ng-container>
    <ng-container>
      <span class="message-timestamp" data-automation-id="message-timestamp">{{ formatDate(message.timestamp) }}</span>
      <span *ngIf="isParticipantNameVisible" class="participant-name" [ngSwitch]="message?.senderType">
        <ng-container *ngSwitchCase="MessageDataSenderType.Bot">{{
          'gcChatBox.messageList.items.workflowParticipantName' | translate
        }}</ng-container>
        <ng-container *ngSwitchCase="MessageDataSenderType.ActualAgent">{{ (actualAgent$ | async).name }}</ng-container>
        <ng-container *ngSwitchCase="MessageDataSenderType.OtherAgent">{{
          (getUserName(message?.senderId) | async) ?? 'gcChatBox.messageList.items.unknownUser' | translate
        }}</ng-container>
      </span>
    </ng-container>
  </div>
</div>
